import React from "react";
import Box from "@mui/material/Box";
import CircleIcon from "@mui/icons-material/Circle";
import Typography from "@mui/material/Typography";
import { Link } from "gatsby";

const Tags = ({ strapiArticle }) => {
  return (
    <>
      <Typography variant="h1" sx={{ mb: 2, mt: 2, ml: { xs: 2, md: 5 } }}>
        {strapiArticle.title}
      </Typography>
      <Box
        sx={{ ml: { xs: 0, sm: 2, md: 5 }, mb: 2 }}
        style={{
          display: "flex",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Typography variant="h10" sx={{ fontWeight: 400 }}>
          By
          {strapiArticle.authors.map(
            (author, index, authorsProp) => (
              <Link
                to={author.path}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                {index.length===1 || index===authorsProp.length - 1 ? (
                  <Typography variant="h10" sx={{ ml: 0.5, cursor: "pointer" }}>
                    {author.name}
                  </Typography>
                ) : (
                  <Typography variant="h10" sx={{ ml: 0.5, cursor: "pointer" }}>
                    {author.name} &
                  </Typography>
                )}
              </Link>
            )
          )}
        </Typography>
        <CircleIcon sx={{ ml: 1, mr: 1, color: "#4F5968", fontSize: 4 }} />
        <Typography variant="h10" sx={{ fontWeight: 400, mr: 1 }}>
          Published in
          <Link
            to={strapiArticle.articleCategory.path}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Typography variant="h10" sx={{ ml: 1, cursor: "pointer" }}>
              {strapiArticle.articleCategory.name}
            </Typography>
          </Link>
        </Typography>
        <CircleIcon sx={{ ml: 1, mr: 1, color: "#4F5968", fontSize: 4 }} />
        <Typography variant="h10" sx={{ color: "#4F5968", fontWeight: 400 }}>
          {strapiArticle.publishedAt}
        </Typography>
      </Box>
    </>
  );
};
export default Tags;
